
    import JSZip from "jszip";

    // Zips the user-selected files client-side into a single archive and uploads it
    // to the `upload_zip` LiveView upload — one request instead of many, which
    // LiveView handles poorly. The names are pushed first so the modal can list the
    // selected files immediately; the server unzips and creates a letter per file.
    // Attached to the drop-zone container, driving both the picker input and drops.
    export default {
      mounted() {
        // The container also holds the hidden `live_file_input` for `upload_zip`
        // (which `this.upload` targets), so query the picker by its explicit role.
        const input = this.el.querySelector("input[data-role=manual-file-picker]");

        input.addEventListener("input", (e) => {
          e.preventDefault();
          this.zipAndUpload(Array.from(e.target.files));
          // Reset so selecting the same files again re-triggers the input event.
          input.value = "";
        });

        this.el.addEventListener("dragover", (e) => {
          e.preventDefault();
          e.dataTransfer.dropEffect = this.disabled() ? "none" : "copy";
        });
        this.el.addEventListener("drop", (e) => {
          // NOTE: The current implementation still allows user to drop an incompatible
          // file (wrong mimetype), but not when using OS's file picker dialog.
          // Such files will become letters but will be immediately rejected.
          // We might want to add mimetype-check here if this becomes an annoyance in production.
          e.preventDefault();
          if (this.disabled()) return;
          this.zipAndUpload(Array.from(e.dataTransfer.files));
        });
      },

      disabled() {
        return this.el.dataset.disabled === "true";
      },

      zipAndUpload(files) {
        if (files.length === 0) return;

        this.pushEvent("upload-files-selected", {
          names: files.map((f) => f.name),
        });

        const zip = new JSZip();
        files.forEach((file) => zip.file(file.name, file, { binary: true }));
        zip
          .generateAsync({ type: "blob" })
          .then((blob) => this.upload("upload_zip", [blob]));
      },
    };
  